var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"align-middle"},[_vm._v(_vm._s(_vm.name))]),_c('b-badge',{staticClass:"badge-outlined ml-1",attrs:{"pill":"","variant":_vm.isAnalyserConfigured ? 'success' : 'danger'}},[_vm._v(" "+_vm._s(_vm.isAnalyserConfigured ? _vm.$t('analyserConfigured') : _vm.$t('analyserNotConfigured'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }